import React from 'react'

export const invisibleEyeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5498 3.807C9.29675 3.5988 11.0638 3.96811 12.5812 4.85854C14.0986 5.74896 15.2828 7.11156 15.9531 8.73825C16.0156 8.90664 16.0156 9.09186 15.9531 9.26025C15.6775 9.9285 15.3133 10.5566 14.8702 11.1277M10.0629 10.6185C9.63859 11.0284 9.07026 11.2551 8.48035 11.25C7.89044 11.2449 7.32614 11.0083 6.90899 10.5911C6.49184 10.1739 6.25522 9.6096 6.2501 9.01965C6.24497 8.42971 6.47175 7.86136 6.88158 7.437M12.609 13.1243C11.6142 13.7136 10.5042 14.082 9.35448 14.2045C8.20471 14.3271 7.04204 14.2008 5.94535 13.8344C4.84867 13.468 3.84363 12.8699 2.99844 12.0808C2.15324 11.2917 1.48767 10.33 1.04688 9.261C0.984374 9.09261 0.984374 8.90739 1.04688 8.739C1.71182 7.12639 2.88179 5.77293 4.38121 4.88175M1.00038 1.5L15.9996 16.5"
      stroke="#555555"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
